export default function actualizarActividad(uuid) {
    setInterval(() => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "./Request/enc/actualizarActividad.php", true);
  
      // Establecer el tipo de contenido como URL codificada
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  
      // Configurar la respuesta cuando se reciba la respuesta del servidor
      xhr.onload = function () {
        if (xhr.status === 200) {
          // Si la petición es exitosa, procesamos la respuesta si es necesario
          //console.log("Hora de última actividad actualizada:", xhr.responseText);
        } else {
          console.error("Error actualizando la actividad:", xhr.status, xhr.statusText);
        }
      };
  
      xhr.onerror = function () {
        console.error("Error en la solicitud.");
      };
  
      // Enviar el request con el ID en formato URL codificado
      xhr.send(`id=${encodeURIComponent(uuid)}`);
    }, 5000); // Cada 5 segundos
  }